// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import { GET_LIST_LINXUP_TRUCK_LOCATION } from '~/utils/constants/actionType';
import linxUpApi from '~/apis/linxUp';
import { IQueryParamTruckLocation } from '~/utils/interface/linxUp';

export const getListTruckLocations = createAsyncThunk(
  GET_LIST_LINXUP_TRUCK_LOCATION,
  async (params: IQueryParamTruckLocation, { rejectWithValue }) => {
    try {
      const resp = await linxUpApi.getListTruckLocations(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
